import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Img} from "react-image";
import {Link} from "react-router-dom";
import {Badge, Divider, List, Modal, Radio, Space, Typography} from "antd";
import UserImageCircle from '../../../components/UserImageCircle';
import LoadingSpinner from "../../../components/LoadingSpinner";
import SpinLoader from "../../../components/SpinLoader";
import {useMutation} from "@tanstack/react-query";
import User from '../../../models/User';
import {useAPI} from "../../../config/API";
import LoadingBanner from "../../../components/LoadingBanner";
import ModalVideo from "react-modal-video";

const ApproveVideoInterviewsModal = (props) => {
    const [isApproveProfileModalOpen, setIsApproveProfileModalOpen] = useState(false);

    let {
        data: talent,
        isFetching: isLoading,
        error,
        refetch
    } = useAPI(['fetchForTalentAsManager', {talentId: props.talent?.id}], {
        enabled: isApproveProfileModalOpen,
        onSuccess: ({data}) => {
            let profile = TB.pick({...data}, [
                'talent_profile_rejection_notes',
                'talent_profile_rejected_at',
                'talent_profile_approved_at',
                'talent_profile_admin_decision',
                'talent_profile_admin_notes',
            ]);

            profile.is_approved = !!profile.talent_profile_approved_at
            profile.is_rejected = !!profile.talent_profile_rejected_at

            return TB.cloneDeep({...profile});
        },
        keepPreviousData: false
    })
    const [previewingVideo, setPreviewingVideo] = useState(null)

    const steps = useMemo(() => {
        if (!talent) {
            return [];
        }
        return TB.map(TB.orderBy(laravel.talent_video_interview_steps || [], 'display_index', 'asc'), step => {
            let existingStep = TB.find(talent?.talent_video_interviews || [], ['step.id', step.id]);

            if (existingStep) {
                let {
                    step:stepInfo,
                    ...latest_interview
                } = existingStep;
                return {
                    ...step,
                    latest_interview
                }
            }
            return step;
        })
    }, [talent, isLoading]);


    // const  =
    const updateVideoApprovalMutation = useMutation(['updateVideoApproval', props.talent?.id],
        async step => {

            let talent_video_interviews = TB.map(talent?.talent_video_interviews, interviewStep => {
                if (interviewStep.id === step.id) {
                    return step;
                }
                return interviewStep;
            })
            let approval_props = {
                talent_video_interviews
            }
            console.log('UPDATE', {approval_props})


            const updatedUser = await User.updateTalentFromManager(talent.id, approval_props)

            if (!updatedUser) {
                throw new Error('Something went wrong!');
            }
            return updatedUser;
        }, {
            onSuccess: async (response) => {

                await TB.queryClient.setQueryData(['fetchForTalentAsManager', {talentId: props.talent?.id}], response)

                // await setIsApproveProfileModalOpen(false)
                return TB.toast('User Profile Updated')

            },
            onError: async (error) => {
                console.error("updateVideoApprovalMutation", error)
                return TB.showServerErrorToast()
            }
        })

    return (
        <div className="flex-1 flex items-stretch flex-col">
            <button
                type="button"
                className="btn btn-link btn-link-primary px-0 m-0 text-center"
                disabled={updateVideoApprovalMutation?.isLoading}
                onClick={() => setIsApproveProfileModalOpen(true)}
            >
                Manage
            </button>

            <Modal
                title="Talent Video Interviews"
                closeable={!updateVideoApprovalMutation.isLoading}
                maskClosable={!updateVideoApprovalMutation.isLoading}
                style={{top: 20}}
                destroyOnClose={true}
                width={700}
                footer={null}
                open={isApproveProfileModalOpen}
                // onCancel={handleClose}
                onClose={() => setIsApproveProfileModalOpen(false)}
                onCancel={() => setIsApproveProfileModalOpen(false)}
            >
                {(!talent || isLoading) ? (
                    <LoadingBanner/>
                ) : (
                    <SpinLoader isLoading={updateVideoApprovalMutation.isLoading}
                                className="flex flex-col items-stretch">
                        <div className="flex gap-4">
                            <div>
                                <Img
                                    loader={(
                                        <div className="img-fluid img-loader"><LoadingSpinner/></div>
                                    )}
                                    unloader={<UserImageCircle user={talent} hideTooltip={true} size={90}/>}
                                    src={talent.image_path}
                                    className="img-grayscale img-fluid h-[90px] w-[90px]"
                                />
                            </div>


                            <div className="user-info-details">
                                <p>
                                    <b>Name:</b> {talent.fullName()}
                                </p>

                                <p>
                                    <b>Job Title:</b> {talent.job_title ? TB.truncate(
                                    TB.capitalize(talent.job_title), {length: 50}
                                ) : 'N/A'}
                                </p>

                                <p>
                                    <b>Location:</b> {talent.location ? <span>
                                    {talent.location.city}{!!talent.location.state && `, ${talent.location.state}`}
                                </span> : 'N/A'}
                                </p>

                                <p>
                                    <b>Email:</b> {talent.email ? (
                                    <a href={`mailto:${talent.email}`}
                                       target="_blank">{talent.email}</a>
                                ) : 'N/A'
                                }
                                </p>
                                {talent.phone && (
                                    <p>
                                        <b>Phone:</b> {talent.phone ? (
                                        <a href={`tel:${talent.phone}`}
                                           target="_blank">{talent.phoneNumber()}</a>
                                    ) : 'N/A'}
                                    </p>
                                )}
                                <p>
                                    <b>Registered
                                        At:</b> {talent.registered_at ? TB.moment(talent.registered_at).format('ll') : "N/A"}
                                </p>
                            </div>

                            <div className='ml-auto'>
                                <Link target="_blank" to={`/talent-profiles/${talent.id}`}
                                      className="btn btn-primary btn-xs my-2">
                                    View Talent Profile
                                </Link>
                            </div>
                        </div>

                        <Divider/>
                        <List itemLayout="vertical" dataSource={steps} renderItem={(item, index) => (
                            <List.Item className="border-t first:border-t-0 py-4">
                                <TalentInterviewStep
                                    isDisabled={updateVideoApprovalMutation.isLoading}
                                    onUpdate={step => updateVideoApprovalMutation.mutate(step)}
                                    talentVideoInterviews={talent.talent_video_interviews}
                                    step={item}
                                    onPreview={setPreviewingVideo}/>
                            </List.Item>
                        )}/>
                        <ModalVideo
                            channel="custom"
                            url={previewingVideo}
                            isOpen={!!previewingVideo}
                            onClose={() => setPreviewingVideo(false)}
                        />
                    </SpinLoader>

                )}
            </Modal>
        </div>
    )
}

export default ApproveVideoInterviewsModal;


const {Title, Text, Paragraph} = Typography;

const TalentInterviewStep = ({step, onPreview, onUpdate, isDisabled}) => {

    const videoRef = useRef(null);
    const [videoLength, setVideoLength] = useState(0);

    useEffect(() => {
        if (videoRef?.current) {
            const totalSeconds = videoRef?.current.duration;

            // Method 2: Wait for metadata to load (more reliable)
            videoRef?.current.addEventListener('loadedmetadata', () => {
                const totalSeconds = videoRef?.current.duration;
                console.log('Video duration in seconds:', totalSeconds);
                try {
                    if (videoRef?.current) {
                        setVideoLength(Math.ceil(totalSeconds));
                    }
                }catch (e) {
                    console.error(e);
                }
            });
        }
    }, [videoRef]);
    return (
        <div className="flex items-start flex-nowrap gap-4">
            <div className="bg-secondary text-white min-w-8 min-h-8 w-8 h-8 rounded-full flex items-center justify-center">
                <span className=" font-semibold">{step.display_index}</span>
            </div>
            <div className="flex flex-col flex-grow items-stretch gap-3">
            <div className="flex flex-col items-stretch flex-grow">
                    <Text strong className="text-base">
                        {step.question}
                    </Text>
                    {step.description && (
                        <div className="text-xs text-gray-500 mt-2"
                             dangerouslySetInnerHTML={{__html: step.description.replace(/<br\s*[\/]?>/gi, ". ")}}/>
                    )}
                <Text type="secondary text-xs mt-1.5">
                    Video response&nbsp; | &nbsp;{TB.pluralize('sec', videoLength || step.target_length_seconds, true)}
                    &nbsp; | &nbsp;Profile Visibility {step.latest_interview?.is_public ? <i className="fas fa-check-circle text-success"/> : <i className="fas fa-times-circle text-danger"/>} &nbsp;

                    {step.latest_interview && (
                        <React.Fragment>
                            &nbsp; | &nbsp;

                            {step.latest_interview?.is_public ? (
                                !step.latest_interview?.is_approved ? (
                                    step.latest_interview?.is_rejected ? (
                                        <Badge color={TB.config('color.danger')} count="Not Approved For Profile"
                                               className="opacity-80 text-xs"/>
                                    ) : (
                                        <Badge color={'#a1a1a1'} count="Pending Approval"
                                               className="opacity-80 text-xs italic"/>
                                    )
                                ) : (
                                    <Badge color={TB.config('color.success')} count="Approved" className="text-xs"/>
                                )
                            ) : (
                                step.latest_interview.is_approved ? (
                                    <Badge color={'#a1a1a1'} count="Approved, Hidden By Talent"
                                           className="opacity-80 text-xs italic"/>
                                ) : (step.latest_interview.is_rejected ? (
                                    <Badge color={TB.config('color.danger')} count="Not Approved For Profile"
                                           className="opacity-80 text-xs"/>
                                ) : (
                                    <Badge color={'#a1a1a1'}
                                           className="opacity-80 text-xs italic" count="Hidden By Talent"/>
                                ))
                            )}
                        </React.Fragment>
                    )}
                </Text>

            </div>

                <div className="flex flex-col items-stretch flex-1">
                    {step.latest_interview ? (
                        <div
                            className="flex flex-col-reverse gap-2">

                            <div>
                                <p className="text-xs font-medium mb-2 underline whitespace-nowrap">
                                    Talent Submission
                                </p>
                                <div>
                                    <div className="flex flex-row gap-6 items-center">
                                        <div
                                            className="relative inline-flex items-start self-start flex-col bg-gray-200 rounded-lg overflow-hidden">
                                            <div className="min-w-52 w-52 relative min-h-[117px] h-[117px]">
                                                <video ref={videoRef} src={step.latest_interview.video_path}
                                                       controls={false}
                                                       width="100%" height="100%"
                                                       className="rounded object-contain"/>
                                            </div>


                                            <div
                                                className="absolute inset-0 bg-black bg-opacity-20 flex flex-col items-center justify-center">
                                                <i className="fas fa-play text-white opacity-70 fa-2x clickable"
                                                   onClick={() => {
                                                       onPreview(step.latest_interview.video_path)
                                                   }}/>
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-start gap-4">

                                            <div className="flex flex-col gap-1.5 items-stretch">
                                                <label htmlFor="" className="col-form-label">
                                                    Allow Video To Be Visible in Profile?
                                                </label>
                                                <Radio.Group
                                                    disabled={isDisabled}
                                                className="flex-1"
                                                value={step.latest_interview.is_approved ? 'approved' : step.latest_interview.is_rejected ? 'rejected' : undefined}
                                                onChange={e => {
                                                    let interview = {...step.latest_interview};
                                                    interview.is_approved = e.target.value === 'approved';
                                                    interview.is_rejected = e.target.value === 'rejected';

                                                    return onUpdate(interview);
                                                }}
                                            >
                                                <Space direction="vertical">
                                                    <Radio value="approved">
                                                        <span>
                                                            Approve
                                                        </span>
                                                    </Radio>
                                                    <Radio value="rejected">
                                                        <span>
                                                            Disable
                                                        </span>
                                                    </Radio>
                                                </Space>
                                            </Radio.Group>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    ) : (
                        <div className="min-w-52 w-52 flex flex-col gap-3">
                            <p className="italic text-xs text-gray-400 font-medium mb-2 underline whitespace-nowrap">
                                Not started
                            </p>
                        </div>
                    )}
                </div>
            </div>

        </div>
    )
};